import { Directive, EventEmitter, Output } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { PreviewImplementation } from './PreviewImplementation';
declare var mediaplayer: any;

@Directive()
export class JioMediaPlayerImplementation {

  private http: any;
  public universalService: any;
  static singleInstance: any;
  public router: any;
  public listService: any;
  public jioMediaPlayer: any;
  public localStorageService: any;
  public previewImplementation : any;
  private currentTime: any = 0;
  public mediaTokenVal: any;
  public mediaStreamUrl: string = '';
  public seekPlayTime: any = false;
  public isVideoStreamingEnd: boolean = false;
  public retryCount: number = 0;
  private togglePreviewButtonsTimer = null;
  @Output('previewError') isErrorInPreviewing: EventEmitter<boolean> = new EventEmitter<boolean>();
  dcGroupCodePicker: any;

  constructor(globalService) {
    this.setHandler(globalService);
  }

  public static getInstance(globalService): JioMediaPlayerImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new JioMediaPlayerImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  setHandler(globalService) {
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.router = globalService.getRouterRef();
    this.listService = globalService.getListServiceRef();
    this.previewImplementation = PreviewImplementation.getInstance(globalService);
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
  }

  async getVideoPlaybackUrl() {
    let self = this;
    var playbackUrl = self.universalService.selectedFile["playbackUrl"];
    playbackUrl = playbackUrl.split(".com")[1];
    if (self.router.url.includes("privatefolder")) {
      await self.listService.getPPFToken();
      self.universalService.isPrivateFolderTokenRequired = true;
    }
    let newPlaybackUrl = playbackUrl + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
    newPlaybackUrl = await self.updateDCGroupCode(newPlaybackUrl);
    return newPlaybackUrl;
  }

  getPlaybackSourceUrl(playbackUrl) {
    return this.http.get(playbackUrl, { responseType: 'text' })
  }

  mediaPlayerStatusFnc(event, mediaPlayerInstance) {
    var self = this;
    //Handle retry
    if (event.detail.type == 'retry') {
      const buttonTextVal = self.getErrorPopupButtonText();
      if(buttonTextVal && buttonTextVal == "OK") { //on ok, close preview
        self.previewImplementation.closePreview();
      } else { // retry
        self.currentTime = mediaPlayerInstance.getCurrentTime();
        self.seekPlayTime = true
        if(self.retryCount < 3) {
          self.retryCount++;
          AppEvents.emit(EventsList.VIDEO_PLAYER_RETRY);
        } else {
          self.previewImplementation.closePreview();
          this.universalService.showToast(TOAST["VIDEO_PLAYER_GENERIC_ERROR"], "error");
        }
      }
    }
    //play handling - keep time and token on track 
    if (event.detail.type == 'play') {
      if(self.universalService.isManualVideoPause && (mediaPlayerInstance.getCurrentTime() > 0)) {
        self.universalService.isManualVideoPause = false;
      }
      self.universalService.isStreaming = true;
      if (self.seekPlayTime) {
        self.seekPlayTime = false;
        mediaPlayerInstance.setCurrentTime(self.currentTime);
      }

      if (self.isVideoStreamingEnd) {
        self.isVideoStreamingEnd = false;
        self.revalidateMediaStreamToken(true);
      } else {
        self.revalidateMediaStreamToken(false);
      }
    }
    if (event.detail.type == 'firstframeloaded') {
      self.universalService.isStreaming = true;
      //if manually paused in last state
      if(self.universalService.isManualVideoPause) {
        mediaPlayerInstance.pause();
      }
    }
    if (event.detail.type == 'ended') {
      self.currentTime = 0;
      self.isVideoStreamingEnd = true;
      self.universalService.isStreaming = false;
      self.universalService.isManualVideoPause = false;
    }
    //Handle pause
    if (event.detail.type == 'pause') {
      self.currentTime = mediaPlayerInstance.getCurrentTime();
      self.updateMediaStreamTime();
      self.universalService.isStreaming = false;
      self.universalService.isManualVideoPause = true;
    }
  }

  mediaPlayerErrorFnc(event, mediaPlayerInstance) {
    var self = this;
    if (event.detail.type == 'Critical') {
      // TO handle based on code
      if (event.detail.info && event.detail.info.errorCode == '9000' && event.detail.info.category !== '') {
        self.universalService.isStreaming = false;
        const errorDetail = event.detail.info.detail;
        const match = errorDetail.match(/status:(\d+)/);
        if (match && match[1]) {
          const statusCode = match[1];
          if (statusCode == "401") { // handle token validation
            self.seekPlayTime = true;
            self.currentTime = mediaPlayerInstance.getCurrentTime();
            self.revalidateMediaStreamToken(true, mediaPlayerInstance);
            self.hideErrorMessage();
            if(self.currentTime > 1) { //some content is streamed
              AppEvents.emit(EventsList.VIDEO_PLAYER_RETRY);
            } else {
              if(self.retryCount < 3) {
                self.retryCount++;
                AppEvents.emit(EventsList.VIDEO_PLAYER_RETRY);
              } else {
                self.previewImplementation.closePreview();
                this.universalService.showToast(TOAST["VIDEO_PLAYER_GENERIC_ERROR"], "error");
              }
            }
          } else if (statusCode == "500") { //handle http 500
            //this.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
            const errorMsgHtml = document.getElementById("mediaerror-msg");
            const htmlString = errorMsgHtml.innerHTML;
            // Replace the text for HTTP 500
            const updatedHTML = this.handleReplacedText(htmlString, TOAST["GENERIC_ERROR"], "OK");
            errorMsgHtml.innerHTML = updatedHTML;
          }
        }
      }
    }
    if (event.detail.type == 'Recovering') { //player will handle, no need to handle anything here 
      // TO DO
    }
  }
  //When there is 401, handle to reauthenticate token and proceed - hide this popup
  hideErrorMessage() {
    var errorPopupElement = document.getElementById("mediaerror-container");
    errorPopupElement.classList.add("hidden");
  }

  // Function to replace text on http 500 error in popup
  handleReplacedText(htmlString, newText, buttonText) {
    // Create a temporary DOM element to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Change text after <br>
    const textAfterBr = tempDiv.querySelector('br')?.nextSibling;
    if (textAfterBr && textAfterBr.nodeType === Node.TEXT_NODE) {
        textAfterBr.nodeValue = newText; // Replace text only if it's a text node
    }

    // Change button text
    const buttonTextElement = tempDiv.querySelector('button .text-button');
    if (buttonTextElement) {
        buttonTextElement.textContent = buttonText; // Replace button text
    }
    return tempDiv.innerHTML;
  }

  getErrorPopupButtonText() {
    const errorMsgHtml = document.getElementById("mediaerror-msg");
    return errorMsgHtml.querySelector('button .text-button').textContent;
  }

  getTokenFromMediaAuth(suc) {
    this.mediaStreamUrl = '';
    let url = '';
    if (suc.includes('&token=')) {
      url = suc.split('&token=');
    } else {
      url = suc.split('?token=');
    }

    if (url[1] != undefined) {
      this.mediaStreamUrl = url[0];
      this.mediaTokenVal = url[1];
    } else {
      this.mediaStreamUrl = url[0];
    }

    if (this.universalService.activeRepo == "share") {
      this.mediaStreamUrl = suc;
    }
  }

  updateMediaStreamTime() {
    var tokenTime = (new Date().getTime() + ENV_CONSTANTS.constants['mediaStreamTokenExpiry']);
    if (this.universalService.selectedFile != undefined) {
      this.localStorageService.setItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME + '_' + this.universalService.selectedFile.objectKey, tokenTime);
    }
  }


  async revalidateMediaStreamToken(isForceCallApi, mediaPlayerInstance?) {
    var self = this;
    if (self.getTimeDifference(isForceCallApi)) {
      var playbackUrl = await self.getVideoPlaybackUrl();
      playbackUrl = playbackUrl + ((self.mediaTokenVal) ? '&tkn=' : '') + self.mediaTokenVal;
      self.getPlaybackSourceUrl(playbackUrl).subscribe(
        suc => {
          let url = suc;
          self.updateMediaStreamTime();          
          // if (self.seekPlayTime) {
          //   self.seekPlayTime = false;
          //   self.currentTime = mediaPlayerInstance.getCurrentTime();
          //   if(mediaPlayerInstance) {
          //     mediaPlayerInstance.setCurrentTime(self.currentTime);
          //     mediaPlayerInstance.play();
          //   }
          // }
        },
        error => {
          self.universalService.showErrorMessage(error);
          //self.retryCount = 0;
        }
      )
    }
  }

  getTimeDifference(isForceCallApi) {
    if (isForceCallApi) {
      return true;
    }
    var currentTime = new Date().getTime();
    var localTime;
    if (this.universalService.selectedFile != undefined) {
      localTime = this.localStorageService.getItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME + '_' + this.universalService.selectedFile.objectKey);
      if (localTime == null) {
        localTime = 0;
      }
    } else {
      localTime = 0;
    }

    if (localTime < currentTime) {
      return true;
    }
    return false;
  }

  togglePreviewButtons() {
    var classRef = this;
    clearTimeout(classRef.togglePreviewButtonsTimer);
    classRef.togglePreviewButtonsTimer = null;
    jQuery("#preview-modal .modal-header").fadeIn();
    jQuery("#preview-modal .modal-footer").fadeIn();

    jQuery("#preview-modal .previousIcon").fadeIn();
    jQuery("#preview-modal .nextIcon").fadeIn();

    classRef.togglePreviewButtonsTimer = setTimeout(function() {
      jQuery("#preview-modal .modal-header").fadeOut();
      jQuery("#preview-modal .modal-footer").fadeOut();
      jQuery("#preview-modal .previousIcon").fadeOut();
      jQuery("#preview-modal .nextIcon").fadeOut();
      if(!classRef.universalService.isMobileDevice){
        classRef.universalService.openMoreOptions = false;
        classRef.universalService.openMoreOptionsContextMenu = false;
      }
      $("#video-container").unbind().bind('click', function() {
        if ($("#shareView .prvw_bnr").is(':visible')) {
          jQuery("#preview-modal .modal-header").fadeOut();
          jQuery("#preview-modal .modal-footer").fadeOut();
          jQuery("#preview-modal .previousIcon").fadeOut();
          jQuery("#preview-modal .nextIcon").fadeOut();
          clearTimeout(classRef.togglePreviewButtonsTimer);
          classRef.togglePreviewButtonsTimer = null;
        } else {
          jQuery("#preview-modal .modal-header").fadeIn();
          jQuery("#preview-modal .modal-footer").fadeIn();
          jQuery("#preview-modal .previousIcon").fadeIn();
          jQuery("#preview-modal .nextIcon").fadeIn();
          classRef.togglePreviewButtons();
        }
      });
      // if ($(window).width() > 767) {
        $("#video-container").bind('mousemove', function() {
          jQuery("#preview-modal .modal-header").fadeIn();
          jQuery("#preview-modal .modal-footer").fadeIn();
          jQuery("#preview-modal .previousIcon").fadeIn();
          jQuery("#preview-modal .nextIcon").fadeIn();
          classRef.togglePreviewButtons();
        });
      // }

    }, 8000);
  }

  async updateDCGroupCode(url){
    let useDefaultDCCode = true;
    if(window.location.href.includes("sharedwithme")){
      await this.dcGroupCodePicker.decideTypeOfShare(this.universalService.selectedFile["shareKey"]);
      useDefaultDCCode = false;
    }else if(window.location.href.includes("?u=")){
      await this.dcGroupCodePicker.decideTypeOfShare(this.universalService.shareKey);
      useDefaultDCCode = false;
    }
    url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url,useDefaultDCCode);
    return url
  }

}
